import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UIUtil } from '../utils/ui.util';
import { session_keys } from '..';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (UIUtil.getPrivateData(session_keys.private_key).email) {
      // logged in so return true.....
      //this.router.navigate(['ats/dashboard'])
      return true;
    }
    // not logged in so redirect to login page with the return url
    this.router.navigate(['login']);
    return false;
  }
}
